import { providerTitleMapping } from './providersBreadcrumbMapping'

export const providerCodeTransform = (code: string) => code.replace(' ', '-')

export const capitalizeTitleName = (title: string) => {
  return title
    .replace(/-/g, ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const getProviderTitle = (title: string) => {
  return providerTitleMapping[title] || capitalizeTitleName(title)
}
